export default __webpack_public_path__ + "static/media/DAOHaus.2dc28266.png";